import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{d-icon this.icon translatedTitle=this.title class=this.cssClasses}}",{ moduleName: "discourse/components/bookmark-icon.hbs" })